/**
 * Shared fixtures for frontend config modules.
 */
module.exports = {
  geoFixtures: [
    {
      label: 'New York, NY, USA',
      location: { lat: 40.7033127, lng: -73.979681 },
    },
    {
      label: 'Chicago, IL, USA',
      location: { lat: 41.881832, lng: -87.623177 },
    },
    {
      label: 'Boston, MA, USA',
      location: { lat: 42.361145, lng: -71.057083 },
    },
    {
      label: 'Phoenix, AZ, USA',
      location: { lat: 33.448376, lng: -112.074036 },
    },
    {
      label: 'Austin, TX, USA',
      location: { lat: 30.266666, lng: -97.73333 },
    },
    {
      label: 'Dallas, TX, USA',
      location: { lat: 32.779167, lng: -96.808891 },
    },
    {
      label: 'Los Angeles, CA, USA',
      location: { lat: 34.052235, lng: -118.243683 },
    },
    {
      label: 'Atlanta, GA, USA',
      location: { lat: 33.753746, lng: -84.38633 },
    },
  ],
};
